import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { posthog } from '../lib/posthog'

export const AnalyticsPageTracker: React.FC = () => {
  const location = useLocation()

  useEffect(() => {
    posthog.capture('$pageview', { $current_url: location.pathname })
  }, [location.pathname])

  return null
}
